import { CustomIcon } from './CustomIcon'
import { CustomIconProps } from './types'

export const PlayButtonIcon = (props: CustomIconProps) => (
  <CustomIcon fill="#686686" height={17} viewBox="0 0 20 20" width={17} {...props}>
    <path
      clipRule="evenodd"
      d="M10 3.125C6.20304 3.125 3.125 6.20304 3.125 10C3.125 13.797 6.20304 16.875 10 16.875C13.797 16.875 16.875 13.797 16.875 10C16.875 6.20304 13.797 3.125 10 3.125ZM1.875 10C1.875 5.51269 5.51269 1.875 10 1.875C14.4873 1.875 18.125 5.51269 18.125 10C18.125 14.4873 14.4873 18.125 10 18.125C5.51269 18.125 1.875 14.4873 1.875 10Z"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M8.45509 6.94895C8.65831 6.84019 8.9049 6.85211 9.09669 6.97997L12.8467 9.47997C13.0206 9.59589 13.125 9.79103 13.125 10C13.125 10.209 13.0206 10.4041 12.8467 10.52L9.09669 13.02C8.9049 13.1479 8.65831 13.1598 8.45509 13.051C8.25187 12.9423 8.125 12.7305 8.125 12.5V7.5C8.125 7.2695 8.25187 7.05772 8.45509 6.94895ZM9.375 8.66782V11.3322L11.3733 10L9.375 8.66782Z"
      fillRule="evenodd"
    />
  </CustomIcon>
)
